import React, { useEffect, useRef, useState } from "react";
import Dashboard from "../../layouts/Dashboard";
import { Card } from "antd";
import ReactLoading from "react-loading";
import exportFromJSON from "export-from-json";
import useRole from "../../hooks/useRole";
import { checkPermission } from "../../utils/checkPermission";

function GenerateXLSX() {
  const [loader, setLoader] = useState(false);
  const [file, setFile] = useState(null);
  const [fileData, setFileData] = useState([]);
  const fileRef = useRef(null)
  const exportType = "csv";
  const [canViewGenerateExcel, setCanViewGenerateExcel] = useState(false);
  const [canGenerateExcel, setCanGenerateExcel] = useState(false);
  const userRole = useRole();

  const checkPermissions = async () => {
    try {
      const [viewAllowed, generateAllowed] = await Promise.all([
        checkPermission(userRole, "generate_excel_module", "view_generate_excel"),
        checkPermission(userRole, "generate_excel_module", "generate_excel"),
      ]);
      setCanViewGenerateExcel(viewAllowed);
      setCanGenerateExcel(generateAllowed);
    } catch (error) {
      console.error("Permission check failed for Generate Excel Module:", error);
    }
  };

  useEffect(() => {
    if (userRole) {
      checkPermissions();
    }
  }, [userRole]);

  const downloadCSV = async (_data) => {
    const flattenArray = (data) => {
      if (!data) return [];
      return data.map((ele) => {
        let flatObject = { ...ele };
        function flatten(obj) {
          Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
              Object.assign(flatObject, obj[key]);
              delete flatObject[key];
            } else if (Array.isArray(obj[key])) {
              console.log("inside array key", obj[key]);
              flatObject[key] = obj[key].toString();
            }
          });
        }

        flatten(ele);
        return flatObject;
      });
    };
    const data = flattenArray(_data);
    exportFromJSON({ data, fileName: file?.name, exportType });
  };

  const onClickHandler = async () => {
    setLoader(true);
    const flattenArray = fileData?.map((ele) => {
      let flatObject = { ...ele };
      function flatten(obj, keyPrefix) {
        Object.keys(obj).forEach((key) => {
          if (typeof obj[key] === "object") {
            Object.assign(flatObject, obj[key]);
            delete flatObject[key];
          }
        });
      }
      flatten(ele, "");
      return flatObject;
    });
    const data = flattenArray;
    downloadCSV(data);
    setFile(null);
    if(fileRef.current) {
        fileRef.current.value = ''
    }
    setLoader(false);
  };

  const changeHandler = async (e) => {
    const file = e.target.files[0] || null;
    setFile(file);
    if (file) {
      const reader = new FileReader();
      reader.onloadstart = (event) => {
        setLoader(true);
      };
      reader.onload = (event) => {
        let data = JSON.parse(event.target.result);
        setFileData(data);
      };
      reader.onloadend = (event) => {
        setLoader(false);
      };
      reader.readAsText(file);
    }
  };

  if (!canViewGenerateExcel) {
    return <div></div>;
  }

  return (
    <>
      <Dashboard title="Generate XLSX">
        {loader && (
          <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
        )}
        <div className="row">
          <div className="col-12">
            <Card title="" className="border mt-3">
              <div className="row">
                <div className="col-md-6">
                  <input ref={fileRef} type="file" onChange={changeHandler} />
                </div>
                 <div className="col-md-6">
                   {canGenerateExcel && (
                     <button
                       className={`btn ${
                         file === null ? "btn-secondary" : "btn-primary"
                       }`}
                       type="submit"
                       style={{ width: "100%" }}
                       disabled={file === null}
                       onClick={onClickHandler}
                     >
                       Download
                     </button>
                   )}
                 </div>
              </div>
            </Card>
          </div>
        </div>
      </Dashboard>
    </>
  );
}

export default GenerateXLSX;
